import * as React from "react";
import { observer } from "mobx-react";
import { Loader, Message } from "sb-resp-ui";

// imported only for typings
// these are passed to the component from index.ts
import { BaseDict } from "./dict";
import { RacingFutureEventsData } from "./data";
import { RacingEventInfo } from "../../data/models/RacingEventInfo";

// external components
import * as CMP from "./components";

@observer
export class RacingFutureEvents extends React.Component<{
    dataProvider: RacingFutureEventsData,
    dict: BaseDict
}, {
    dataProvider: RacingFutureEventsData
}> {
    dict: BaseDict

    constructor(props) {
        super(props);
        this.dict = this.props.dict;
        this.state = {
            dataProvider: this.props.dataProvider,
        }
    }

    /* istanbul ignore next */
    renderRows(rows: RacingEventInfo[]) {
        return rows.map(x => {
            return (
                <CMP.Row>
                    <CMP.Cta url={this.state.dataProvider.getFutureEventUrl(x.urlCode, x.leagueId)} handler={this.state.dataProvider.getFutureEventHandler(x)}>
                        <CMP.League date={x.formattedDate} time={x.formattedTime} label={x.eventName} />
                        <CMP.Icon />
                    </CMP.Cta>
                </CMP.Row>
            )
        })
    }

    /* istanbul ignore next */
    renderLoader() {
        return (
            <div className="rj-racing-future-events__loader">
                <Loader />
            </div>
        )
    }

    /* istanbul ignore next */
    renderMessage() {
        return <Message text="test message" />;
    }

    /* istanbul ignore next */
    render() {
        let l = this.state.dataProvider.getAntepostEvents.length;
        return (
            <div className="rj-racing-future-events">
                {(!l || l === 0) && this.renderLoader()}
                {false && this.renderMessage()}
                {(l > 0) && this.renderRows(this.state.dataProvider.getAntepostEvents)}
            </div>
        )
    }
}
